module.exports = {
  "country": "IL",
  "artist": "Noa Kirel",
  "song": "Unicorn",
  "year": "2023",
  "place": "3",
  "spotify": "6dUregFbvUNqHP5nphqesK"
};